/**
 * Heart bonus part meters (Weak / Heart / Strong Heart).
 * Authoritative target: `config/exploreUnknownBattleBonuses.json` → bonuses.*.collectParts.targetParts
 */
export const EXPLORE_UNKNOWN_HEART_TARGET_PARTS = 3;

/** @typedef {'weak' | 'normal' | 'strong'} ExploreUnknownHeartVariant */

/**
 * @type {ReadonlyArray<{
 *   id: 'weakHeart' | 'heart' | 'strongHeart',
 *   gameStateKey: string,
 *   apiKey: string,
 *   apiKeySetsCompleted: string,
 *   image: string,
 *   variant: ExploreUnknownHeartVariant,
 *   healthBonus: number,
 *   i18nKey: string,
 * }>}
 */
export const EXPLORE_UNKNOWN_HEART_METERS = Object.freeze([
  {
    id: 'weakHeart',
    gameStateKey: 'exploreUnknownWeakHeartPartsCollected',
    apiKey: 'weakHeartPartsCollected',
    apiKeySetsCompleted: 'weakHeartSetsCompleted',
    image: '/images/weak_heart.jpg',
    variant: 'weak',
    healthBonus: 1,
    i18nKey: 'weakHeart',
  },
  {
    id: 'heart',
    gameStateKey: 'exploreUnknownHeartPartsCollected',
    apiKey: 'heartPartsCollected',
    apiKeySetsCompleted: 'heartSetsCompleted',
    image: '/images/heart.jpg',
    variant: 'normal',
    healthBonus: 2,
    i18nKey: 'heart',
  },
  {
    id: 'strongHeart',
    gameStateKey: 'exploreUnknownStrongHeartPartsCollected',
    apiKey: 'strongHeartPartsCollected',
    apiKeySetsCompleted: 'strongHeartSetsCompleted',
    image: '/images/strong_heart.jpg',
    variant: 'strong',
    healthBonus: 3,
    i18nKey: 'strongHeart',
  },
]);
